import { Component, OnInit, Input } from '@angular/core';
import { RxComponent } from 'app/core/components/common/rx.component';
import { FormGroup } from '@angular/forms';
import { AccountService } from 'app/agora/components/account-data/accounts/account.service';
import { NotificationService } from 'app/core/services/notification.service';
import { ConfigDto } from 'app/shared/models/config-dto.interface';
import { objectComparatorFactory } from 'app/shared/utils/object-comparator.util';

const consolidationOrdersFrequencyOptionWeightMap = {
  'acof-week': 1,
  'acof-month': 2,
  'acof-quarter': 3,
};

function consolidationOrdersFrequencyOptionSortComparator(a: ConfigDto, b: ConfigDto): number {
  const aWeight: number = consolidationOrdersFrequencyOptionWeightMap[a.configKey] || 0;
  const bWeight: number = consolidationOrdersFrequencyOptionWeightMap[b.configKey] || 0;
  return aWeight - bWeight;
}

@Component({
  selector: 'itpx-update-finance',
  templateUrl: './update-finance.component.html',
  styleUrls: ['./update-finance.component.css']
})
export class UpdateFinanceComponent extends RxComponent implements OnInit {

  @Input() form: FormGroup;

  readonly configurationDtoComparator = objectComparatorFactory<ConfigDto>('configKey');
  currencyDto: { key: string, value: string }[] = [];
  consolidationOrdersFrequencyOptions: ConfigDto[] = [];
  // levelPolicies: any = [];
  // actionPolicies: any = [];

  constructor(
    private accountService: AccountService,
    private notificationService: NotificationService
  ) {
    super();
  }

  ngOnInit() {
    this.accountService.getCurrencyDto().subscribe(
      (body) => {
        this.currencyDto = body.data;
      },
      (error) => this.handleError(error)
    );
    this.accountService.getConsolidationOrdersFrequencyList().subscribe(
      (body) => {
        this.consolidationOrdersFrequencyOptions = [null, ...body.data.sort(consolidationOrdersFrequencyOptionSortComparator)];
      },
      (error) => this.handleError(error)
    );

    // this.accountService.getLevelPolicies()
    //   .subscribe(
    //     body => {
    //       let levelPolicyList = body.data;
    //       for (let i = 0; i < levelPolicyList.length; i++) {
    //         let levelPolicyObj = levelPolicyList[i];
    //         this.levelPolicies.push({ key: levelPolicyObj.key, value: levelPolicyObj.value });
    //       }
    //     },
    //     error => this.handleError(error)
    //   );

    // this.accountService.getActionPolicies()
    //   .subscribe(
    //     body => {
    //       let actionPolicyList = body.data;
    //       for (let i = 0; i < actionPolicyList.length; i++) {
    //         let actionPolicyObj = actionPolicyList[i];
    //         this.actionPolicies.push({ key: actionPolicyObj.key, value: actionPolicyObj.value });
    //       }
    //     },
    //     error => this.handleError(error)
    //   );
  }

  private handleError(error: any) {
    this.notificationService.error(error, 'Failed');
  }

}



// WEBPACK FOOTER //
// ./src/app/agora/components/account-data/accounts/edit/update-finance/update-finance.component.ts